

import React, { useEffect, useState } from "react";
import { Layout, Input, Checkbox, Form, Carousel, Image, message } from "antd";
import { useNavigate } from "react-router-dom";
import "./Login.css"; // Include your styles here
import CryptoJS from "crypto-js";
import PrimaryButton from "../components/TableComponent/ButtonComponent/Buttons";
import authService from "../networks/api/service/authService";
import logo from "../assets/images/bjp final.png";
import colors from "../assets/styles/colour";
const { Content } = Layout;
const SECRET_KEY = "secret123!";
const encryptData = (data) => {
  return CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
};
console.log("Encrypted Password:", encryptData("test1234"));

const decryptData = (data) => {
  try {
    const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    return "";
  }
};
console.log("Encrypted Password:", encryptData("test1234"));
const Login = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isEmail, setIsEmail] = useState(true); 
  // const [rememberMe, setRememberMe] = useState(false);
  const [rememberMe, setRememberMe] = useState(
    localStorage.getItem("rememberMe") === "true"
  );
  const [emailOrPhone, setEmailOrPhone] = useState(
    rememberMe ? localStorage.getItem("emailOrPhone") || "" : ""
  );
  const [password, setPassword] = useState(
    rememberMe ? decryptData(localStorage.getItem("password")) : ""
    

  );

  const [loading, setloading] = useState(false);

  const handleInputChange = (value) => {
    // Simple regex to check if it's an email or phone number
    const isEmailInput = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    setIsEmail(isEmailInput);
  };

  const LoginUser = async (values) => {
    setloading(true);
    try {
      if (isEmail) {
        const data = {
          email: values.emailOrPhone,
          password: values.password,// abc
        };

        const res = await authService.login(data);
        if (res.code === 200) {
          message.success("Sign-in successful");
          localStorage.setItem("email", values.emailOrPhone);
          localStorage.setItem ("password", values.password);
          localStorage.setItem("JWTtoken", res.user.token);
          localStorage.setItem("UserRole", res.user.role);
          // Grievance Admin sign-in responses provide `id` (not `adminId`).
          // Keep one storage key for all roles and use whichever ID is present.
          localStorage.setItem("adminRoleId", res.user.adminId || res.user.id || "");

          
          if (rememberMe) {
            localStorage.setItem("rememberMe", true);
            localStorage.setItem("emailOrPhone", values.emailOrPhone);
            localStorage.setItem("password" , encryptData(values.password));
          } else {
            localStorage.removeItem("rememberMe");
            localStorage.removeItem("emailOrPhone");
            // localStorage.removeItem("password");
          }

          if (res.user.role === "ADMIN") {
            navigate("/login/dashboard");
          } else if (res.user.role === "GRIEVANCEADMIN"){
            navigate("/login/grievance ");
          } else {
            navigate("/login/dashboard");
          }
        }
      } else {
        const payload = {
          phoneNo: values.emailOrPhone,
        };

      
        const res = await authService.verifyMobile(payload);
        if (res.code === 200) {
          message.success("OTP sent to your mobile number.");
          localStorage.setItem("phoneNo", values.emailOrPhone);

          navigate("/verify-otp");
        }
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.response?.data || error.message;
      message.error(`Error: ${errorMessage}`);
    }
    setloading(false);
  };

  useEffect(() => {
    const storedRememberMe = localStorage.getItem("rememberMe") === "true";
    setRememberMe(storedRememberMe);
    const storedEmailOrPhone = localStorage.getItem("emailOrPhone");
    const storedPassword = localStorage.getItem("password");
  
    // Autofill email & password if they exist in localStorage
    if (storedEmailOrPhone) {
      form.setFieldsValue({
        emailOrPhone: storedEmailOrPhone,
        password: storedPassword ? decryptData(storedPassword) : "",
        remember: storedRememberMe,
      });
    } else {
      // Clear form if no stored credentials
      form.setFieldsValue({
        emailOrPhone: "",
        password: "",
        remember: false,
      });
    }
  
    
  }, [form]);
  

  const handleRememberMe = (e) => {
    const isChecked = e.target.checked;
    setRememberMe(isChecked); // Update state immediately
    localStorage.setItem("rememberMe", isChecked ? "true" : "false"); 
  
  };
  

  return (
    <Layout className="login-layout">
      <Content className="login-container">
        {/* <div className="login-left">
          <div className="carousel-container">
            <Carousel autoplay autoplaySpeed={3000} effect="fade">
              {slides.map((slide, index) => (
                <div key={index}>
                  <Image src={slide} width={630} height={300} preview={false} />
                </div>
              ))}
            </Carousel>
          </div>
        </div> */}
        <div className="login-left custom-flag-section">
  {/* <div className="flag-overlay-text">
    <h2>Namaste! Welcome to Karyalay</h2>
    <p>Karyalay is your one-stop digital gateway for seamless civic services. Whether you’re booking appointments, submitting grievances, managing transport, or participating in surveys — everything is just a click away. Empowering citizens. Simplifying governance. Building a better India, together.
      <br/>
      From travel and transport to grievances and surveys — Karyalay is designed to make public services smarter and more accessible. Transparent. Efficient. Citizen-first. A new step towards a digitally empowered India.
    </p>
  </div> */}
</div>

        <div className="login-right">
          <div className="login-box">
            <div>
              <Image
                src= {logo}
                // width={250}
                // height={250}
                marginBottom={-20}
                alt="Logo"
                preview={false}
                style={{ marginBottom: -20, backgroundColor: "transparent",height:"250px",width:"300px",display:"flex",justifyContent:"center",alignItems:"center" }}
              
              />
            </div>
            <h2 className="login-title">Login to your Account</h2>
            <Form
              form={form}
              className="login-form"
              onFinish={LoginUser} // Submit handler
            >
              <Form.Item
                name="emailOrPhone"
                initialValue={emailOrPhone}
                rules={[
                  {
                    required: true,
                    message: "Please input your email or phone number!",
                  },
                ]}
              >
                <Input
                  placeholder="Email or Phone Number"
                  className="login-input"
                  style={{ backgroundColor: "#E5E4E2" }}
                  onChange={(e) => {
                    setEmailOrPhone(e.target.value);
                    handleInputChange(e.target.value);
                  }}
                />
              </Form.Item>

              {isEmail && (
                <Form.Item
                  name="password"
                  initialValue={password}
                  rules={[
                    { required: true, message: "Please input your password!" },
                  ]}
                >
                  <Input.Password
                    placeholder="Password"
                    className="login-input"
                    style={{ backgroundColor: "#E5E4E2" }}
                    onChange={(e)=> {
                      setPassword(e.target.value)
                    }}
                  />
                </Form.Item>
              )}

              <div className="login-options">
                <Form.Item name="remember" valuePropName="checked" noStyle>
                  <Checkbox 
                  className="remember-me"
                  checked={rememberMe}
                  onChange={handleRememberMe}
                  >Remember Me</Checkbox>
                  <div style={{ textAlign: "right", marginBottom: "10px" }}>
  <span
    style={{ color: colors.button, cursor: "pointer", fontWeight: 500 }}
    onClick={() => navigate("/forgot-password")}
  >
    Forgot Password?
  </span>
</div>
                </Form.Item>
              </div>

              <Form.Item>
                <PrimaryButton htmlType="submit" className="login-btn">
                  {loading ? "Loading..." : "Login"}
                </PrimaryButton>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Content>
    </Layout>
  );
};

export default Login;
